module.exports = __webpack_public_path__ + "static/media/13.12523145.jpg";